<template>
  <!-- 
  1.화면ID    : MCP_CL_003
  2.화면명    : 회사 분류체계관리 이력조회
  3.작성자    : 손승완 대리
  4.화면설명  : 년도별 기준 회사분류체계 이력조회 화면  
              최초 조회조건은 해당년도 >>>>>>  리비전으로 변경되었음. 
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
-->

  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="" class="form-label"> 리비전번호</label>
            <select v-model="state.companyClsParams.srivision" class="form-select" aria-label="Default select example">
              <option v-for="(item, index) in state.codeList" :key="index" :value="item.rev_id">{{ item.rev_id }}
              </option>
            </select>

          </div>
        </div>
      </div>
    </div>

    <div class="search-detail-wrap"></div>
    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getDataList()">검색</ElButton>
    </div>

    <div class="table-responsive table-list">
      <DataTable :value="state.gridRowData"  paginator :rows="20"
        :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        >
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <!--체크박스 컬럼-->
        <Column>
          <template #header>
            <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
            <ElCheckbox 
            v-model="state.selectRows" 
            :value="data.index"
            />
          </template>
        </Column>
        <!--데이터 매핑 컬럼-->
        <Column v-for="company of state.gridColumn" :field="company.field" :header="company.headerName"
          :style="company.cellStyle" :key="company.field">
          <template #body="{data,field}">
            <div :class="company.class">{{data[field]}}</div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>

</template>

<script setup>

import { reactive, onMounted, computed } from 'vue';
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { classHisList, getRevIdList } from '@/api/comp';




onMounted(() => {
  getSearchCondition();

})

//변수 선언 영역 
const state = reactive({

  companyClsParams: {

    /// year   : sYear,
    ////rev_id : 'RV2024004',  //조회조건 변경으로 의한 테스트 진행
  },


  codeList: [],
  selectRows: [],

  gridRowData: [],
  //컬럼 셋팅
  gridColumn: [
    { headerName: '적용연도', field: "rev_id" ,class:"blank-div",cellStyle:{maxWidth:'100px'}},
    { headerName: '1단계', field: "class_nm1" ,class:"blank-div",cellStyle:{maxWidth:'100px'}},
    { headerName: '2단계', field: "class_nm2" ,class:"blank-div",cellStyle:{maxWidth:'100px'}},
    { headerName: '3단계', field: "class_nm3" ,class:"blank-div",cellStyle:{maxWidth:'100px'}},
    { headerName: '4단계', field: "class_nm4" ,class:"blank-div",cellStyle:{maxWidth:'100px'}},
    { headerName: '활성화여부', field: "enable_yn",cellStyle:{textAlign : 'center'} },
    { headerName: '메모', field: "note" ,class:"blank-div"},
    { headerName: '수정일자', field: "fmt_upd_dt",cellStyle:{textAlign : 'center'} },
  ]

});
  
const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue
      ? state.gridRowData.map((item) => {
        return String.item.index;
      })
      : [];
  },
});

const getDataList = async () => {
  let params = {
    rev_id: state.companyClsParams.srivision
  }

  try {
    setIsLoading(true)
    const res = await classHisList(params)
    state.gridRowData = res.rtn.map((item,index)=>{
      item.index = index
      return item
    });
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}



const getSearchCondition = async () => {
  try {
    setIsLoading(true)
    const res = await getRevIdList()
    state.codeList = res.rtn;
    state.companyClsParams.srivision = res.rtn[0].rev_id;
    getDataList()
  } catch (err) {
    alert("조회 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};


</script>